import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataSharedService } from 'src/app/services/data-shared.service';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { SuccessModal } from 'src/app/app.model';
import { IMPORT_FIELD_ENDPOINTS } from 'src/app/app.constant';
import { normalizeImportFields } from 'src/app/utils/import-field-normalizer';

@Component({
  selector: 'app-column-mapping-import',
  templateUrl: './column-mapping-import.component.html',
  styleUrls: ['./column-mapping-import.component.css']
})
export class ColumnMappingImportComponent {
  @Input() systemFields: { key: string; label: string }[] = [];
  @Input() previewUrl: string;
  @Input() startUrl: string;
  @Input() importUrl: string = '/api/import/start';
  @Input() templateKey: string = 'defaultMappingTemplate';
  @Input() entity: string;


  isOpen = false;
  selectedFile: File | null = null;
  headers: string[] = [];
  headerLabels = [];
  previewRows: any[] = [];
  columnMapping: { [header: string]: string | null } = {};
  loading = false;



  constructor(
    private activeModalService: NgbActiveModal,
    private dataSharedService: DataSharedService,
    private modalService: NgbModal,
  ) { }


  ngOnInit() {
    if (!this.systemFields.length) {
      this.loadSystemFields();
    }
  }

  loadSystemFields() {
    const endpoint = IMPORT_FIELD_ENDPOINTS[this.entity];

    if (!endpoint) {
      console.warn(`No field endpoint configured for entity: ${this.entity}`);
      return;
    }

    this.dataSharedService.getImportFields(endpoint).subscribe(res => {
      console.log(res.data[0].fields)
      const fields = res.data[0].fields

      this.systemFields = normalizeImportFields(this.entity, res);
      console.log(`[${this.entity}] systemFields`, this.systemFields);
      console.log(this.systemFields);
    });
  }

  open() {
    this.reset();
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  reset() {
    this.selectedFile = null as any;
    this.headers = [];
    this.headerLabels = [];
    this.previewRows = [];
    this.columnMapping = {};
    this.loading = false;
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      this.previewFile();
    }
  }



  previewFile() {

    const formData = new FormData();

    if (!this.selectedFile) {
      return;
    }

    formData.append('file', this.selectedFile);

    this.loading = true;

    this.dataSharedService.importPreview(this.previewUrl, formData).subscribe({
      next: (res) => {
        this.headers = res.headers;
        this.previewRows = res.rows;
        this.headerLabels = res.headerLabels;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  startImport() {
    if (!this.selectedFile) return;

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('mapping', JSON.stringify(this.columnMapping));
    console.log(this.columnMapping);
    this.dataSharedService.importStart(this.startUrl, formData).subscribe({
      next: () => {
        this.successModal('Imported process started !! We will notify once the process is completed.')
      },
      error: () => alert('Error starting import')
    });
  }

  successModal(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });

    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 3500,
    }

    modalRef.componentInstance.data = data;
    modalRef.result.then(() => {
      this.activeModalService.close();
    });
  }

  onClose() {
    this.activeModalService.close();
  }
}
